export default "__VITE_ASSET__798e2688__"